import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Camille D.',
  location: 'Paris, France'
}, {
  name: 'Julien M.',
  location: 'Lyon, France'
}, {
  name: 'Léa R.',
  location: 'Bordeaux, France'
}, {
  name: 'Thomas P.',
  location: 'Lille, France'
}, {
  name: 'Sophie L.',
  location: 'Nantes, France'
}, {
  name: 'Mathieu B.',
  location: 'Toulouse, France'
}, {
  name: 'Claire V.',
  location: 'Strasbourg, France'
}, {
  name: 'Antoine G.',
  location: 'Marseille, France'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    let dismissTimer: number | undefined;
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      dismissTimer = window.setTimeout(() => setVisible(false), 6000);
    };
    const initialTimer = window.setTimeout(showPopup, 4000);
    const interval = window.setInterval(showPopup, 16000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
      if (dismissTimer) window.clearTimeout(dismissTimer);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-183">
      <aside className="bg-white border-2 border-brand-gold shadow-[0_0_18px_rgba(216,175,61,0.65)] rounded-lg p-2.5 pr-8 max-w-[285px] w-full relative overflow-hidden pointer-events-auto" aria-live="polite" data-id="element-184">
        <div className="absolute top-0 left-0 w-full h-1 bg-brand-violet" data-id="element-185" />
        <button onClick={() => setVisible(false)} aria-label="Fermer la notification" className="absolute top-1.5 right-1.5 text-brand-muted hover:text-brand-navy transition-colors" data-id="element-186">
          <XIcon className="w-4 h-4" data-id="element-187" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-188">
          <div className="w-9 h-9 rounded-full bg-brand-violet/10 flex items-center justify-center shrink-0 border border-brand-violet/30" data-id="element-189">
            <ShoppingBagIcon className="w-4 h-4 text-brand-violet" data-id="element-190" />
          </div>
          <div className="leading-tight" data-id="element-191">
            <p className="font-heading font-bold text-brand-navy text-xs" data-id="element-192">
              {current.name}
            </p>
            <p className="text-[10px] text-brand-muted font-bold" data-id="element-193">
              {current.location}
            </p>
            <p className="text-[11px] text-brand-violet font-extrabold mt-0.5" data-id="element-194">
              vient d’acheter le livre numérique GYMNASTIQUE PRO™
            </p>
          </div>
        </div>
      </aside>
    </div>;
}